<template>
  <div class="container py-5" v-if="etu">

    <div class="row mb-4">
      <div class="col-md-3 text-center">
        <img
          v-if="etu.user?.urlImage"
          :src="getImageUrl(etu.user.urlImage)"
          alt="Photo disciple"
          class="detail-photo"
        />

        <img
          v-else
          :src="defaultPhoto"
          alt="Photo par défaut"
          class="detail-photo"
        />
      </div>

      <div class="col-md-5">
        <h2>{{ etu.nom }} {{ etu.prenom }}</h2>

        <p v-if="etu.qualification">
          <strong>Qualification:</strong> {{ etu.qualification.libelle }}
        </p>

        <p><strong>Matricule :</strong> {{ etu.numeroMatricule}}</p>
        <p><strong>Sexe :</strong> {{ etu.sexe}}</p>
        <p><strong>Email :</strong> {{ etu.email }}</p>
        <p><strong>Téléphone :</strong> {{ etu.telephone1 }}</p>
        <p><strong>Anne Experience:</strong> {{ etu.anneeExperience }}</p>
       
      </div>
      <div class="col-md-4">
        <br><br>
      <ul v-if="etu.inscriptions?.length">
        <li v-for="inscription in etu.inscriptions" :key="inscription.id">
          <p><strong>Filière :</strong>{{ inscription.filiere?.libelle }}</p>
          <p><strong>Niveau:</strong> {{ inscription.niveau?.libelle }}</p>
          <p><strong>Année Académique :</strong>{{ new Date(inscription.dateInscription).getFullYear() }}</p>
           <p><strong>Autre Qualification:</strong> {{ etu.autreQualification}}</p>
           
        </li>
      </ul>
      </div>
    </div>
    

    <hr />

    <h4>Date de naissance</h4>
    <p>{{ formatDate(etu.dateNaissance) }}</p>

    <hr />

    <!-- MATIÈRES ENSEIGNÉES -->
    <h4>Biographie</h4>
    <p>{{etu.biographie}}</p>

      <!-- <hr />
      <h4>Lieu de Résidence</h4> -->
      <!-- <h4>Filiere</h4>
      <p v-if="etu.inscriptions && etu.inscriptions.filiere">{{etu.inscriptions.filiere.libelle}}</p> -->
      <!-- <p>Departement : <strong>{{ etu.quartier.arrondissement.commune?.departement?.libelle}}</strong></p>
      <p>Arrondissement : <strong>{{ etu.quartier.arrondissement.libelle}}</strong></p>
      <p>Commune :<strong>{{ etu.quartier.arrondissement.commune.libelle}}</strong></p> 
      <p>Quartier : <strong>{{ etu.quartier.libelle}}</strong></p> -->
         
      
      
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "DisciplesDetail",

  setup() {
    const formatDate = (dateStr: string) => {
        if (!dateStr) return "Non renseignée";
        return new Date(dateStr).toLocaleDateString("fr-FR");
    };

    const route = useRoute();
    const etu = ref<any>(null);
    const defaultPhoto = "/22.png";

    const getEtudiant = async () => {
      try {
        const response = await ApiService.get(`/etudiants/${route.params.id}`);
        etu.value = response.data.data;
        console.log("ttttt",etu.value)
      } catch (error) {
        console.error(error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    onMounted(getEtudiant);

    return {
      etu,
      defaultPhoto,
      formatDate,
      getImageUrl
    };
  },
});
</script>
<style>
    
.detail-photo {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 4px solid #ffc107;
  object-fit: cover;
}

.matiere-list li {
  list-style: disc;
  margin-left: 20px;
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

</style>

